import script from "./CardsResumeFact.vue?vue&type=script&setup=true&lang=js"
export * from "./CardsResumeFact.vue?vue&type=script&setup=true&lang=js"

import "../styles/cardsResumeFact.css?vue&type=style&index=0&id=3ff6dd8a&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ff6dd8a"]])

export default __exports__